import {z} from 'zod'
import {Timezone} from '../timezone/index.js'

export const UserSettings = z.object({
  timezone: Timezone,
  firstDayOfWeek: z.number().int().min(0).max(6),
  timeFormat: z.enum(['12h', '24h']),
})
export type UserSettings = z.infer<typeof UserSettings>
